import { useLastPathSegment } from 'shared/hooks'
import { useNewInboxStepsContext } from 'pages/settings/pages/inboxes/pages/newInbox/context/newInboxStepsContext'

export const useProgressInfoTitle = () => {
  const { getProgressInfoTitle } = useNewInboxStepsContext()

  return getProgressInfoTitle(useLastPathSegment())
}
